import { useEffect, useState } from 'react';

type Activity = {
  wallet: string;
  amount: number;
  time: string;
};

export const useLiveActivity = () => {
  const [activity, setActivity] = useState<Activity[]>([]);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    const generateSolanaAddress = () => {
      const base58 = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
      let address = '';
      for (let i = 0; i < 44; i++) {
        address += base58.charAt(Math.floor(Math.random() * base58.length));
      }
      return address;
    };
    
    const generateActivity = () => {
      const wallet = generateSolanaAddress(); // full address
      const shortWallet = `${wallet.slice(0, 4)}...${wallet.slice(-4)}`; // shortened for display
      const amount = Math.floor(Math.random() * (200 - 3 + 1)) + 3;
      const time = new Date().toLocaleTimeString();
    
      const newActivity: Activity = { wallet: shortWallet, amount, time };
    
      setActivity((prev) => [newActivity, ...prev].slice(0, 100));
    
      const nextInterval = Math.floor(Math.random() * (45000 - 5000 + 1)) + 5000;
      timeout = setTimeout(generateActivity, nextInterval); // schedule next one
    };

    // start initial activity generation
    generateActivity();

    return () => clearTimeout(timeout); // cleanup on unmount
  }, []);

  return activity;
};
